<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="sequence"
              attribute="attributes.sort"
              :label="$t('attributes.sort')"
            >
              <b-select v-model="form.sequence" name="sequence">
                <option
                  v-for="option in sequence_range"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="title"
              attribute="attributes.question"
              :label="$t('attributes.question')"
            >
              <b-input
                v-model="form.title"
                name="title"
                :placeholder="
                  $t('message.please_input') + $t('attributes.question')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group horizontal name="note" :label="$t('attributes.note')">
              <b-input
                v-model="form.note"
                name="note"
                :placeholder="
                  $t('message.please_input') + $t('attributes.note')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="type"
              attribute="attributes.question_type"
              :label="$t('attributes.question_type')"
            >
              <b-select v-model="form.type" name="type">
                <option value="0">
                  {{ $t('attributes.question_select') }}
                </option>
                <option value="1">
                  {{ $t('attributes.question_multi') }}
                </option>
                <option value="2">
                  {{ $t('attributes.question_fill') }}
                </option>
                <option value="3">
                  {{ $t('attributes.question_date') }}
                </option>
                <option value="4">
                  {{ $t('attributes.question_image') }}
                </option>
              </b-select>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ question.id ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'CommonQuestionForm',

  props: {
    question: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sequence_range: [...Array(50).keys()].map(i => i + 1),

      sending: false,
      form: this.extractFormValues(this.question),

      options: this.question.options || []
    }
  },
  validations: {
    form: {
      sequence: {},
      title: { required, maxLength: maxLength(50) },
      note: { maxLength: maxLength(50) },
      type: {}
    }
  },
  computed: {
    formTitle() {
      return (
        this.$t(this.question.id ? 'attributes.modify' : 'attributes.add') +
        this.$t('attributes.common_question')
      )
    }
  },
  watch: {
    question(newQuestion) {
      this.form = this.extractFormValues(newQuestion)
      this.options = newQuestion.options || []
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        sequence: data.sequence || 10,
        title: data.title || '',
        note: data.note || '',
        type: data.type || 0
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
